import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Button, Col, MenuProps, Popover, Row, Menu } from 'antd';
import { useRouter } from 'next/router';
import styles from '@styles/SideBar.module.scss';
import { DownOutlined } from '@ant-design/icons';
import { toLower } from 'lodash';
import Link from 'next/link';

type Props = { siderBarInfos: any[]; routerPath: Array<string> };

const AppSiderBar = ({ siderBarInfos = [], routerPath }: Props) => {
    // console.log(siderBarInfos);
    const formatedRouterPath = useMemo(
        () =>
            routerPath.map((r) => {
                return toLower(r);
            }),
        [routerPath]
    );
    const rootSubmenuKeys = siderBarInfos.map((i) => {
        return i.key;
    });

    const labelMaps = useCallback((arr: any[]) => {
        return arr.map((a: any) => {
            const item = { ...a };
            if (item.keyurl) {
                item.label = (
                    <Link href={item.keyurl} prefetch={false}>
                        {item.label}
                    </Link>
                );
            }
            if (item.children) {
                item.children = labelMaps(item.children);
            }
            return item;
        });
    }, []);
    const items = useMemo(() => labelMaps(siderBarInfos), [labelMaps, siderBarInfos]);
    const defaultSelectedKeys = useMemo(() => {
        let keys: any[] = [],
            list: any[] = [];
        formatedRouterPath.slice(1).forEach((i) => {
            const arr = list.length > 0 ? list : items;
            const item: any = arr.find((a) => {
                return a.keyname === i;
            });
            if (item) {
                keys.push(item.key);
                if (item.children) {
                    list = item.children;
                }
            }
        });
        return keys;
    }, [items, formatedRouterPath]);
    const [openKeys, setOpenKeys] = useState(defaultSelectedKeys);
    const [title, setTitle] = useState('');
    const [desc, setDesc] = useState('');
    const [openPopver, setOpenPopver] = useState(false);
    const titleStyles = styles[formatedRouterPath[formatedRouterPath.length - 2]] || '';
    const setTopBarDesc = useCallback(
        (key?: any) => {
            const getLabelItem = (arr: Array<any>, e: any) => {
                return arr.find((k) => k.keyname === e);
            };

            let title = siderBarInfos[0].label;
            let searchList = siderBarInfos.slice(1);
            formatedRouterPath.slice(1).forEach((e, index) => {
                let labelItem = getLabelItem(searchList, e);
                if (index < formatedRouterPath.slice(1).length - 1) {
                    // title += ` - ${labelItem?.label}` || '';
                    searchList = labelItem?.children || [];
                } else {
                    setDesc(labelItem?.labelname);
                }
            });
            setTitle(title);
        },
        [formatedRouterPath, siderBarInfos]
    );

    useEffect(() => {
        setTopBarDesc();
    }, [setTopBarDesc]);
    const onClick: MenuProps['onClick'] = (e: any) => {
        setOpenPopver(false);
        setTopBarDesc(e.key);
        // const keyPath = e.keyPath;
        // keyPath.push(siderBarInfos[0].key);
        // const url = keyPath.reverse();
        // router.push(`/${e.item.props.keyurl}`);
    };
    const onOpenChange: MenuProps['onOpenChange'] = (keys: any) => {
        const latestOpenKey = keys.find((key: any) => openKeys.indexOf(key) === -1);
        if (rootSubmenuKeys.indexOf(latestOpenKey!) === -1) {
            setOpenKeys(keys);
        } else {
            setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
        }
    };
    return (
        <>
            <Row>
                <Col xs={0} md={24}>
                    <Menu
                        onClick={onClick}
                        defaultSelectedKeys={defaultSelectedKeys}
                        openKeys={openKeys}
                        mode='inline'
                        items={items}
                        className={styles.appSiderMenu}
                        onOpenChange={onOpenChange}
                    ></Menu>
                </Col>
                <Col xs={24} md={0} className={styles.appSiderMenuMobile}>
                    <div className={styles.contain}>
                        <div className={`${styles.title} ${titleStyles}`}>{title}</div>
                        <div className={styles.desc}>
                            <span>{desc}</span>
                            <Popover
                                placement='bottomRight'
                                content={
                                    <Menu
                                        onClick={onClick}
                                        defaultSelectedKeys={defaultSelectedKeys}
                                        openKeys={openKeys}
                                        mode='inline'
                                        items={items}
                                        className={styles.appSiderMenu}
                                        onOpenChange={onOpenChange}
                                    ></Menu>
                                }
                                trigger='click'
                                overlayClassName={styles.siderOverlay}
                                arrowPointAtCenter={true}
                                open={openPopver}
                                onOpenChange={(open) => {
                                    setOpenPopver(open);
                                }}
                            >
                                <Button
                                    className={styles.appSiderMenuBtn}
                                    icon={<DownOutlined />}
                                ></Button>
                            </Popover>
                        </div>
                    </div>
                </Col>
            </Row>
        </>
    );
};

export default AppSiderBar;
